import { Box, Checkbox, Chip, IconButton, List, ListItemIcon, Menu, MenuItem } from "@mui/material"
import { getAuth, onAuthStateChanged } from "firebase/auth"
import { collection, doc, getDoc, getDocs, onSnapshot, query, updateDoc, where } from "firebase/firestore"
import { useEffect, useState } from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { db } from ".."
import LoadingScreen from "../components/LoadingScreen"
import { Container } from "@mui/system"

import DoneIcon from '@mui/icons-material/Done';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

var user = {}

export default function ReadList(props) {

    const [loading, setLoading] = useState(true)
    const [hatms, setHatms] = useState([])
    const [userData, setUserData] = useState({});
    const [chosenHatms, setChosenHatms] = useState([]);
    const [readAnchorEl, setReadAnchorEl] = useState(null);

    // asc des(azalan)'dayken yukarıda en yeni eleman gözükecek
    // asc(yükselen)'deyken yukarıda en eski eleman gözükecek
    const [readOrder, setReadOrder] = useState("des")

    // false ise kendi ve diğer insanlarınkini gösterir
    // true iken sadece kullanıcının hatimleri gözükür
    const [isMine, setIsMine] = useState(false)

    const isRestricted = props.isRestricted

    const readListOpen = Boolean(readAnchorEl);



    const handleReadListClick = (event) => {
        setReadAnchorEl(event.currentTarget);
    };

    const handleReadListClose = () => {
        setReadAnchorEl(null);
    };

    const navigate = useNavigate()
    let auth = getAuth()

    function getDb() {

        getDoc(doc(db, "users", auth.currentUser.uid)).then((doc) => {
            user = doc.data()

            if (Object.keys(user.hatms).length > 0) {

                const q = query(collection(db, 'hatms'), where("id", "in", Object.keys(user.hatms)))

                getDocs(q).then(response => {
                    setHatms(response.docs.map(doc => {
                        return doc.data()
                    }))

                    setUserData({ ...user })

                    setLoading(false)
                }, [])
            } else {
                setLoading(false)
            }

        })
    }

    function changeReadState(hatm, juz) {
        const currentReadState = userData.hatms[hatm.id]?.[juz]?.read;
        if (typeof currentReadState !== 'undefined') {
            updateDoc(doc(db, "users", auth.currentUser.uid), {
                [`hatms.${hatm.id}.${juz}.read`]: !currentReadState
            }, { merge: true })
        }
    }

    function getHatms(user) {
        let ids = Object.keys(user.hatms)
        let batch = []

        let done = false

        let hatmsData = []


        for (let i = 0; !done; i++) {

            batch = ids.slice(i * 10, i !== 0 ? (i + 1) * 10 : 10)

            if (batch < 11) {
                done = true
            }

            if (ids.length > 0 && batch.length > 0) {

                const q = query(collection(db, 'hatms'), where("id", "in", batch))

                getDocs(q).then(response => {
                    response.docs.map(doc => {
                        hatmsData.push(doc.data())
                    })

                    setHatms(hatmsData)
                    setUserData({ ...user })
                    setLoading(false)
                }, [])

            } else {
                setHatms([])
                setUserData({ ...user, hatms: [] })
                setLoading(false)
            }

        }
    }

    function ReadList() {

        // isMine
        // order

        //console.log('hatms', hatms)
        //console.log("userData", userData)

        var processedHatms = []

        hatms.map(hatm => {
            processedHatms.push({
                ...hatm,
                juzs: userData.hatms[hatm.id]
            })
        })


        if (isMine) {
            processedHatms = processedHatms.filter(hatm => hatm.creator === auth.currentUser.uid)
        }

        // Birisi aşağıdaki işlem sonucunda okuma listesinde kaç eleman olduğunu gösteriyor
        // Diğeri de 5 taneden fazla render etmemek için render anında değeri artırılarak 5'e sınırlıyor
        var juzCounter = 0
        var juzCounter2 = 0

        processedHatms
            .sort(function (a, b) {
                return readOrder === "asc" ? a.endDate - b.endDate : b.endDate - a.endDate;
            })
            .map((hatm, i) => {
                return Object.keys(hatm.juzs)
                    .filter(juz => !hatm.juzs[juz].read)
                    .map(juz => {
                        juzCounter++
                    })
            })

        console.log(processedHatms)

        return <>
            <List
                sx={{ width: '100%', bgcolor: 'background.paper' }}
                aria-label="contacts">

                {
                    juzCounter < 1 ? <Box sx={{ padding: "20px", backgroundColor: "#F9F9F9", margin: "15px 0", display: "flex", justifyContent: "center", borderRadius: "10px" }}>
                        <p>Okuma listende hiç cüz yok.</p>
                    </Box> : processedHatms
                        .sort(function (a, b) {
                            console.log(a.endDate, b.endDate)
                            return readOrder === "asc" ? a.endDate - b.endDate : b.endDate - a.endDate;
                        })
                        .map((hatm, i) => {
                            return Object.keys(hatm.juzs)
                                .filter(juz => !hatm.juzs[juz].read)
                                .map(juz => {

                                    const isRead = userData.hatms[hatm.id][juz].read

                                    juzCounter2++

                                    if (isRestricted ? juzCounter2 < 6 : true) {
                                        return <Box key={juz} sx={{
                                            border: "solid 1px",
                                            padding: "5px 15px",
                                            borderRadius: "10px",
                                            marginTop: "4px",
                                            display: "flex", justifyContent: "space-between", alignItems: "center"
                                        }}>
                                            <div style={{ display: "flex" }}>
                                                <IconButton onClick={() => changeReadState(hatm, juz)}> {hatm.juzs[juz].read ? <RemoveDoneIcon /> : <DoneIcon />}  </IconButton>
                                                <NavLink to={"/hatimler/" + hatm.id} style={{ all: "unset" }}>{isRead ? <p><s>{hatm.title}</s></p> : <p>{hatm.title}</p>}</NavLink>
                                            </div>
                                            <Chip sx={{ backgroundColor: isRead ? "#D7E1D7" : "#B0C4B1", borderRadius: "10px" }} label={<p style={{ color: "white" }}>{juz}. Cüz</p>} />
                                        </Box>
                                    }
                                })
                        })
                }
                <br />
                {
                    !isRestricted &&
                    processedHatms
                        .sort(function (a, b) {
                            return readOrder === "asc" ? a.endDate - b.endDate : b.endDate - a.endDate;
                        })
                        .map((hatm, i) => {
                            return Object.keys(hatm.juzs).filter(juz => hatm.juzs[juz].read).map(juz => {

                                const isRead = userData.hatms[hatm.id][juz].read

                                return <Box key={juz} sx={{
                                    border: "solid 1px",
                                    padding: "5px 15px",
                                    borderRadius: "10px",
                                    marginTop: "4px",
                                    display: "flex", justifyContent: "space-between", alignItems: "center"
                                }}>
                                    <div style={{ display: "flex" }}>
                                        <IconButton onClick={() => changeReadState(hatm, juz)}> {hatm.juzs[juz].read ? <RemoveDoneIcon /> : <DoneIcon />}  </IconButton>
                                        <NavLink to={"/hatimler/" + hatm.id} style={{ all: "unset" }}>{isRead ? <p><s>{hatm.title}</s></p> : <p>{hatm.title}</p>}</NavLink>
                                    </div>
                                    <Chip sx={{ backgroundColor: isRead ? "#D7E1D7" : "#B0C4B1", borderRadius: "10px" }} label={<p style={{ color: "white" }}>{juz}. Cüz</p>} />
                                </Box>
                            })
                        })
                }
            </List>



        </>
    }

    useEffect(() => {

        onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                getDb()
                console.log("test")

                onSnapshot(doc(db, "users", auth.currentUser.uid), (doc) => {
                    getHatms(doc.data())
                });


            } else {
                // User is signed out
                window.location.href = '/tanitim';
            }
        }, []);

        /* Object.keys(userData?.hatms).map(hatmId => {
            const hatm = userData.hatms[hatmId]

            if( Object.keys(hatm).length > 0 ) {
                setIsAnyRead(true)
            }
        }) */

    }, [])

    if (loading) {
        return <LoadingScreen />
    }

    return <>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
            {
                chosenHatms.length < 1 ? <><h3 onClick={() => { isRestricted && navigate("/okumalistem") }}>Okuma Listem</h3>
                    <div>

                        <IconButton onClick={handleReadListClick}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={readListOpen ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={readListOpen ? 'true' : undefined}>
                            <FilterListIcon />
                        </IconButton>

                    </div></> : <>

                    <h3>{chosenHatms.length} Seçildi</h3>

                </>
            }

            <Menu
                anchorEl={readAnchorEl}
                id="account-menu"
                open={readListOpen}
                onClose={handleReadListClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => {
                    setReadOrder(readOrder === 'asc' ? 'des' : 'asc')
                }}>
                    <ListItemIcon>
                        {readOrder === 'asc' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                    </ListItemIcon>
                    Bitiş Tarihi
                </MenuItem>

                {/* <MenuItem onClick={() => { setIsMine(!isMine) }}>
                    <ListItemIcon>
                        <Checkbox sx={{ padding: "0" }} checked={isMine} />
                    </ListItemIcon>
                    Oluşturduklarım
                </MenuItem> */}
            </Menu>
        </div>

        <ReadList />

    </>


}